import {
  GET_FOOD_ITEMS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/items/get'

import { PlainSearchDropdown } from 'app/common/ui-next/plain-search-dropdown'
import { LoadItemsParams } from 'app/common/ui-next/plain-search-dropdown/types'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import { api } from 'app/api'
import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'
import { PlainInputNumber } from 'app/common/ui-next/plain-input'
import { Dish } from 'app/dataTypes/dishes/dish'

import { Field, subFieldName } from './types'

export const DishTechComponentsTableRow = ({
  id,
  index,
  dish,
  gross,
  net,
  onDelete,
  onChangeDish,
  onChangeGross,
  onChangeNet,
  className,
  cellClassName,
  inputClassName,
}: {
  id: string
  index: number
  dish: Dish | null
  gross: string
  net: string
  onDelete?: () => void
  onChangeDish?: (dish: Dish | undefined) => void
  onChangeGross?: (gross: string) => void
  onChangeNet?: (net: string) => void
  className?: string
  cellClassName?: string
  inputClassName?: string
}) => {
  const handleLoadItems = async ({ limit, offset, search, signal }: LoadItemsParams) => {
    const res = await api.request(GET_FOOD_ITEMS, {
      additionalAxiosOptions: {
        signal,
      },
      error: 'Не удалось загрузить сырье',
      convertions: {
        convertParams,
        convertResult,
      },
      params: {
        limit,
        search,
        offset,
        // TODO только сыръе
      },
    })
    if (res) {
      const { items, total } = res
      return {
        items,
        hasMore: offset + limit < total,
      }
    }

    return { items: [], hasMore: true }
  }

  return (
    <div className={className} role="row" id="row-1">
      <div className={cellClassName} role="cell">
        <PlainSearchDropdown
          placeholder="Выберите…"
          value={dish || undefined}
          id={subFieldName(Field.RawItem, id, Field.RawItemDishId)}
          onChange={onChangeDish}
          loadItems={handleLoadItems}
        />
      </div>
      <div className={cellClassName} role="cell">
        <PlainInputNumber
          className={inputClassName}
          id={subFieldName(Field.RawItem, id, Field.RawItemGross)}
          name={subFieldName(Field.RawItem, id, Field.RawItemGross)}
          value={gross.replace(',', '.')}
          onChange={(e) => onChangeGross?.(e.target.value)}
          disabled={!dish}
          step="0.01"
          wide
        />
      </div>
      <div className={cellClassName} role="cell">
        <PlainInputNumber
          className={inputClassName}
          id={subFieldName(Field.RawItem, id, Field.RawItemNet)}
          name={subFieldName(Field.RawItem, id, Field.RawItemNet)}
          value={net.replace(',', '.')}
          onChange={(e) => onChangeNet?.(e.target.value)}
          disabled={!dish}
          step="0.01"
          wide
        />
      </div>
      <input
        type="hidden"
        name={subFieldName(Field.RawItem, id, Field.RawItemIndex)}
        value={index}
      />
      {!!dish && (
        <div className={cellClassName} role="cell">
          <PlainButtonAsLink aria-label="Удалить этот компонент" onClick={() => onDelete?.()}>
            <PlainIcon
              type={iconType.LIGHT_CROSS}
              color={iconColor.COLOR_GRAY}
              width={16}
              height="auto"
            />
          </PlainButtonAsLink>
        </div>
      )}
    </div>
  )
}
